import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducers";
// import { createLogger } from "redux-logger";
// const loggerMiddleware = createLogger();
// , loggerMiddleware
const store = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware), //  , loggerMiddleware
  
);

export default store;
